import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/formfnsimplerectificatif/step4';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { TypeFNSSimpleDescMarche2 } from '../models/TypeFNSSimpleDescMarche2';
import { SimpREControlNames } from '../services/simpREControleNames';
@Component({
  selector: 'app-type-desc-marche',
  templateUrl: './type-desc-marche.component.html'
})
export class TypeDescMarcheComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeDescMarche'
  @Input() parentForm: FormGroup;
  @Input() natureMarche: TypeFNSSimpleDescMarche2;
  @Input() disabled: boolean;
  public rbNatureMarche = "";

	travauxValue = RadioCheckBoxEnum.travauxValue;
	servicesValue = RadioCheckBoxEnum.servicesValue;
	fournituresValue = RadioCheckBoxEnum.fournituresValue;

	public radioButtonValue: string;
  public radioButtonCtrlName: string;

  public step4 = new Step4();

  constructor() { }

  public ngOnInit() {
    if (this.natureMarche.natureMarche.fournitures == RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = RadioCheckBoxEnum.fournituresValue;
    }
    else if (this.natureMarche.natureMarche.services == RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = RadioCheckBoxEnum.servicesValue;
    } else {
      this.radioButtonValue = RadioCheckBoxEnum.travauxValue;
    }
  }


  getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}





  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

